import ApiService from '../../../../shared/services/ApiService';

export default {
    getList(uid) {
        return ApiService.get(`user-pay-rates/${uid}`);
    },

    create(data){
        return ApiService.post(`user-pay-rates`, data);
    },
    delete(id){
        return ApiService.delete(`user-pay-rates/${id}`);
    },
    update(id, data){
        return ApiService.put(`user-pay-rates/${id}`, data);
    }
}